var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWeight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_117_63)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.7373 10.5685L10.6898 4.31037C10.5912 3.7203 10.0802 3.28906 9.48207 3.28906H7.90812C8.09268 2.96751 8.19821 2.59501 8.19821 2.19834C8.19821 0.986223 7.21225 0 5.99988 0C4.78776 0 3.80154 0.986223 3.80154 2.19834C3.80154 2.59501 3.90708 2.96751 4.09164 3.28906H2.51768C1.9193 3.28906 1.40851 3.72082 1.30999 4.31089L0.26268 10.5698C0.203153 10.9246 0.303231 11.2898 0.53588 11.5643C0.768789 11.8391 1.11035 12 1.47063 12H10.5302C10.8904 12 11.232 11.8391 11.4649 11.5643C11.6973 11.2893 11.7971 10.9236 11.7373 10.5685ZM6.00014 1.28074C6.50599 1.28074 6.91774 1.69249 6.91774 2.1986C6.91774 2.7047 6.50599 3.11619 6.00014 3.11619C5.49403 3.11619 5.08228 2.70444 5.08228 2.19834C5.08228 1.69223 5.49403 1.28074 6.00014 1.28074Z",
    fill: "#3CBD96"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_117_63"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeight);
export default __webpack_public_path__ + "static/media/weight.2909667fde34bfd26b1fd3a6d133095a.svg";
export { ForwardRef as ReactComponent };